import React from 'react';
import warningBlockSyle from './style';

export default function WarningBlock({addonStyle, texts, mt, bgColor, color}) {
	let style = warningBlockSyle();
	return (
		<div
			style={{
				...style.outerStyle({mt: mt, bgColor: bgColor, color: color}),
				...addonStyle,
			}}
		>
			{texts ? (
				texts.map((text, i) => {
					return (
						<p key={i} style={style.textStyle()}>
							{text}
						</p>
					);
				})
			) : (
				<></>
			)}
		</div>
	);
}
